import { render, staticRenderFns } from "./Lead.vue?vue&type=template&id=55701cfb"
import script from "./Lead.vue?vue&type=script&lang=js"
export * from "./Lead.vue?vue&type=script&lang=js"
import style0 from "./Lead.vue?vue&type=style&index=0&id=55701cfb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports